import { takeLatest, call, put } from "redux-saga/effects";
import {
  ADD_CUSTOMERS_STATE,
  ADD_CUSTOMERS,
  ADD_NEW_CUSTOMER_STATE,
  UPDATE_CUSTOMER_STATE,
  ADD_NEW_ADDRESS_STATE,
  ADD_NEW_ORDER_STATE,
  REMOVE_CUSTOMER_ADDRESS_STATE,
  ADD_NEW_CUSTOMER,
  UPDATE_CUSTOMER,
  ADD_NEW_ADDRESS,
  ADD_NEW_ORDER,
  REMOVE_CUSTOMER_ADDRESS,
  IMPORT_NEW_CUSTOMERS,
} from "../../constants/actions-types";
import {
  findAllCustomer,
  saveCustomer,
  removeAddress,
  updateAddress,
  updateOrder,
  updateCustomer,
} from "./methods/customerMethods";

function* workerFindAllCustomers(action) {
  try {
    const result = yield call(findAllCustomer, action.page);
    yield put({ type: ADD_CUSTOMERS_STATE, customers: result });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerSaveAllCustomers(action) {
  try {
    let customers = JSON.parse(action.customers);
    const result = yield call(saveCustomer, customers);
    yield put({ type: ADD_CUSTOMERS });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerSaveCustomer(action) {
  try {
    console.log(action.customer);
    const result = yield call(saveCustomer, action.customer);
    yield put({ type: ADD_NEW_CUSTOMER_STATE, customer: result });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerUpdateCustomer(action) {
  try {
    const result = yield call(
      updateCustomer,
      action.selected,
      action.selectCustomer
    );
    yield put({ type: UPDATE_CUSTOMER_STATE, customer: action.selectCustomer });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerAddAddress(action) {
  try {
    const result = yield call(updateAddress, action.selected, action.address);
    console.log(result);
    yield put({ type: ADD_NEW_ADDRESS_STATE, address: action.address });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerAddOrder(action) {
  try {
    const result = yield call(updateOrder, action.selected, action.order);
    console.log(result);
    yield put({ type: ADD_NEW_ORDER_STATE, order: action.order });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerRemoveAddress(action) {
  try {
    const result = yield call(removeAddress, action.selected, action.address);
    yield put({ type: REMOVE_CUSTOMER_ADDRESS_STATE, address: action.address });
  } catch (ex) {
    console.log(ex);
  }
}

function* watcherSaveAllCustomers() {
  yield takeLatest(IMPORT_NEW_CUSTOMERS, workerSaveAllCustomers);
}

function* watcherFindAllCustomers() {
  yield takeLatest(ADD_CUSTOMERS, workerFindAllCustomers);
}

function* watcherSaveCustomer() {
  yield takeLatest(ADD_NEW_CUSTOMER, workerSaveCustomer);
}

function* watcherUpdateCustomer() {
  yield takeLatest(UPDATE_CUSTOMER, workerUpdateCustomer);
}

function* watcherAddAddress() {
  yield takeLatest(ADD_NEW_ADDRESS, workerAddAddress);
}

function* watcherAddOrder() {
  yield takeLatest(ADD_NEW_ORDER, workerAddOrder);
}

function* watcherRemoveAddress() {
  yield takeLatest(REMOVE_CUSTOMER_ADDRESS, workerRemoveAddress);
}

export {
  watcherSaveCustomer,
  watcherUpdateCustomer,
  watcherAddAddress,
  watcherAddOrder,
  watcherRemoveAddress,
  watcherFindAllCustomers,
  watcherSaveAllCustomers,
};
